import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Images from "./Images";
import Carte from "./Carte";
import { faCreditCard, faClock, faLocationDot, faClipboardCheck, faHandHoldingDollar } from "@fortawesome/free-solid-svg-icons";

const ImagesEtDetails = ({ item }) => {

    return (
        <Wrapper>
            <Images tour={item.tableauImg} photos={item.images} />
            <h4><FontAwesomeIcon icon={faClock} /> <span>Durée</span></h4>
            <p>{item.duree}</p>
            <h4><FontAwesomeIcon icon={faCreditCard} /> <span>Prix</span></h4>
            {
                item.prix === null
                    ? <p>Le prix variera selon la durée, le contenu et le nombre de personnes.</p>
                    : <p>{item.prix} $ pour un groupe de 10 personnes ou moins</p>
            }
            <h4><FontAwesomeIcon icon={faLocationDot} /> <span>Point de départ suggéré</span></h4>
            <ul>
                {
                    item.depart.map((itemD, indexD) => {
                        return (
                            <li key={indexD}>{itemD}</li>
                        )
                    })
                }
            </ul>
            {
                item.titre !== "Visite sur mesure" &&
                <>
                    <Carte item={item} />
                    <h4><FontAwesomeIcon icon={faClipboardCheck} /> <span>Inclus</span></h4>
                    <ul>
                        {
                            item.inclus.map((itemI, indexI) => {
                                return (
                                    <li key={indexI}>{itemI}</li>
                                )
                            })
                        }
                    </ul>
                    <h4><FontAwesomeIcon icon={faHandHoldingDollar} /> <span>Extra</span></h4>
                    <ul>
                        {
                            item.exclus.map((itemE, indexE) => {
                                return (
                                    <li key={indexE}>{itemE}</li>
                                )
                            })
                        }
                    </ul>
                </>
            }
        </Wrapper>
    )
}

const Wrapper = styled.div`
    display: block;
    margin: 0 auto;
    max-width: 450px;
`

export default ImagesEtDetails;